import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface EditItemModalProps {
  isOpen: boolean;
  initialText: string;
  title?: string;
  onSave: (newText: string) => void;
  onCancel: () => void;
}
export function EditItemModal({
  isOpen,
  initialText,
  title = 'Edit Item',
  onSave,
  onCancel
}: EditItemModalProps) {
  const [text, setText] = useState(initialText);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (isOpen) {
      setText(initialText);
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [isOpen, initialText]);
  const handleSave = () => {
    const trimmed = text.trim();
    if (trimmed && trimmed !== initialText) {
      onSave(trimmed);
    } else {
      onCancel();
    }
  };
  return <AnimatePresence data-id="element-1852">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onCancel} className="absolute inset-0 bg-black/30 backdrop-blur-sm z-40" data-id="element-1853" />
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 rounded-t-2xl z-50 px-5 pt-4 pb-6" data-id="element-1854">
            <div className="flex items-center justify-between mb-4" data-id="element-1855">
              <h3 className="text-base font-bold text-gray-900" data-id="element-1856">{title}</h3>
              <button onClick={onCancel} className="p-2 text-gray-400 hover:text-gray-900 transition-colors rounded-full hover:bg-gray-100" data-id="element-1857">
                <XIcon className="w-5 h-5" data-id="element-1858" />
              </button>
            </div>

            <textarea ref={inputRef} value={text} onChange={e => setText(e.target.value)} onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSave();
          }
          if (e.key === 'Escape') onCancel();
        }} rows={3} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm text-gray-900 placeholder-gray-400 outline-none focus:border-yellow-400/50 resize-none leading-relaxed" data-id="element-1859" />

            <div className="flex gap-3 mt-4" data-id="element-1860">
              <button onClick={onCancel} className="flex-1 py-2.5 rounded-xl bg-white border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-100 transition-colors" data-id="element-1861">
                Cancel
              </button>
              <button onClick={handleSave} disabled={!text.trim()} className="flex-1 py-2.5 rounded-xl bg-yellow-400 text-gray-900 text-sm font-bold disabled:opacity-40 hover:bg-yellow-300 transition-colors" data-id="element-1862">
                Save
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}